import React from 'react';

/**
 * SpeechTelephone
 *
 * Simple svg icon.
 * As this is only for a temporal landing page it is not moved to DS.
 * Fixed mobile visibility: explicit dimensions with responsive scaling
 */
const SpeechTelephone = () => (
  <svg
    width="100%"
    height="99"
    viewBox="0 0 99 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      minWidth: '80px',
      minHeight: '80px',
      maxWidth: '120px',
      maxHeight: '120px',
    }}
  >
    <rect
      x="0.9375"
      y="0.5"
      width="97.125"
      height="97.125"
      rx="20.5625"
      fill="white"
    />
    <rect
      x="0.9375"
      y="0.5"
      width="97.125"
      height="97.125"
      rx="20.5625"
      stroke="#0A1F44"
    />
    <g clipPath="url(#clip0_10348_3600)">
      <path
        d="M56.854 57.2826C55.8171 56.2457 54.1791 56.0843 52.9585 56.8967L49.6864 59.0781C45.1504 57.0791 41.4833 53.412 39.4844 48.876L41.6657 45.604C42.4795 44.3833 42.3167 42.7453 41.2799 41.7085L37.8149 38.2435C37.1888 37.6174 36.3291 37.2958 35.4419 37.3444C34.5586 37.3995 33.7396 37.8313 33.1949 38.5296L30.7457 41.6783C29.0671 43.8373 28.8413 46.776 30.1696 49.1661C34.6609 57.2511 41.3087 63.9002 49.3937 68.3903C50.4293 68.9651 51.5672 69.2486 52.7026 69.2486C54.1857 69.2486 55.6583 68.7643 56.8829 67.8128L60.0316 65.3636C60.7298 64.819 61.1616 64 61.2167 63.1166C61.2706 62.2346 60.9437 61.3697 60.3177 60.7436L56.8527 57.2786L56.854 57.2826ZM58.4185 63.2951L55.2698 65.7443C53.9442 66.7733 52.1382 66.915 50.6682 66.0986C43.0124 61.8461 36.7163 55.5501 32.4638 47.8943C31.6474 46.4256 31.7866 44.6183 32.8182 43.2926L35.2673 40.144C35.3789 40.0009 35.5259 39.9707 35.6046 39.9655H35.6322C35.7136 39.9655 35.8448 39.9865 35.959 40.1006L39.424 43.5656C39.5789 43.7205 39.6038 43.966 39.4817 44.1484L36.9092 48.0058C36.6691 48.3641 36.6218 48.8196 36.7819 49.2212C39.0617 54.924 43.6397 59.5007 49.3412 61.7805C49.7376 61.9393 50.1931 61.8947 50.5566 61.6532L54.4141 59.0807C54.5952 58.96 54.8393 58.9836 54.9968 59.1385L58.4618 62.6035C58.5904 62.7321 58.5996 62.8804 58.597 62.9591C58.5917 63.0379 58.5629 63.1849 58.4185 63.2965V63.2951Z"
        fill="#0A1F44"
      />
      <path
        d="M56.875 29.875C50.3611 29.875 45.0625 35.1736 45.0625 41.6875C45.0625 43.6339 45.5508 45.5528 46.4787 47.2748L45.1176 51.8108C44.9798 52.2741 45.1058 52.7742 45.4471 53.1154C45.6964 53.3648 46.0311 53.5 46.375 53.5C46.501 53.5 46.627 53.4816 46.7517 53.4449L51.2877 52.0838C53.0097 53.0117 54.9272 53.5 56.875 53.5C63.3889 53.5 68.6875 48.2014 68.6875 41.6875C68.6875 35.1736 63.3889 29.875 56.875 29.875ZM56.875 50.875C55.2094 50.875 53.5688 50.413 52.129 49.5415C51.9229 49.4155 51.6867 49.3512 51.4491 49.3512C51.3218 49.3512 51.1958 49.3696 51.0724 49.4063L48.3319 50.2292L49.1549 47.4888C49.2612 47.1331 49.2126 46.7498 49.0197 46.4322C48.1482 44.9911 47.6862 43.3504 47.6862 41.6862C47.6862 36.6212 51.8088 32.4987 56.8737 32.4987C61.9386 32.4987 66.0612 36.6212 66.0612 41.6862C66.0612 46.7511 61.9386 50.8737 56.8737 50.8737L56.875 50.875Z"
        fill="#0A1F44"
      />
    </g>
    <defs>
      <clipPath id="clip0_10348_3600">
        <rect
          width="40.125"
          height="40.125"
          fill="white"
          transform="translate(29.4375 29)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SpeechTelephone;
